/**
 * @engine/core - Viewport module
 *
 * Shared viewport rendering infrastructure for both editor and player.
 *
 * @module @engine/core
 */

// Types
export type {
  ViewportCameraState,
  ViewportRenderRequest,
  ViewportRenderResult,
} from './ViewportTypes';
export { FPSLimiter } from './ViewportTypes';

// Base renderer
export {
  BaseViewportRenderer,
  screenToWorld,
  worldToScreen,
} from './BaseViewportRenderer';
export type {
  IViewportRenderer,
  RenderStats,
} from './BaseViewportRenderer';

// Game view renderer
export { GameViewRenderer } from './GameViewRenderer';

// Shared scene sprite collection + draw core
export { SceneSpriteCollector } from './scene/SceneSpriteCollector';
export type {
  CollectedSprite,
  SpriteCollectorDeps,
  ForwardLitParams,
} from './scene/SceneSpriteCollector';

// Scriptable render pipeline (viewport pass system)
export { RenderPipeline, ViewportPass, CallbackPass, RenderStage, BB } from './RenderPipeline';
export type {
  ViewportPassContext,
  LightingResources,
  ViewportRenderCallbacks,
} from './RenderPipeline';

// Shared render passes (core / both viewports)
export {
  CollectLightsPass,
  InjectVfxLightsPass,
  CullLightsPass,
  ComputeShadowsPass,
} from './passes/LightingPasses';
export {
  GBufferOpaquePass,
  DeferredAccumPass,
  ForwardPlusOpaquePass,
  UnlitOpaquePass,
  TransparentSpritesPass,
  ParticlesPass,
} from './passes/ContentPasses';
export { PostProcessPass } from './passes/PostProcessPasses';
